/**
 * @file Abstract base class.
 * @author Tom Verschoore de la Houssaije
 */
import { SubscriptionPool } from '../../core/helpers/subscription-pool';
/**
 * Abstract base class.
 */
var AbstractBase = /** @class */ (function () {
    /**
     * Creates an instance of AbstractBase.
     * @memberOf AbstractBase
     */
    function AbstractBase() {
        /** Keep track of the subscriptions */
        this.subscriptionPool = new SubscriptionPool();
    }
    /**
     * Is called before the destruction of the component
     */
    AbstractBase.prototype.ngOnDestroy = function () {
        this.subscriptionPool.unsubscribeAll();
    };
    return AbstractBase;
}());
export { AbstractBase };
